<template>
  <div class="d_flex flex_direction_col" style="width:917px">
    <div class="nav_w">
      <!-- 导航头 -->
      <div
        ref="navHead"
        class="nav_head"
        :class="isActiveTab ? 'is_fixed' : ''"
        style="width:917px"
      >
        <ul class="d_flex fz16 c_1A1A1A">

          <li @click="onTabAnchor('firstTab')">
            <el-button
              :class="firstActive ? 'is_active' : ''"
            >项目信息</el-button>
          </li>

          <li v-if="hasOtherAttachs" @click="onTabAnchor('secondTab')">
            <el-button
              :class="secondActive ? 'is_active' : ''"
            >相关附件</el-button>
          </li>

          <li @click="onTabAnchor('thirdTab')">
            <el-button
              :class="thirdActive ? 'is_active' : ''"
              class="record_btn"
            >出价记录（<em
              class="bids_num"
              :class="thirdActive ? 'c_fff' : 'c_0983CC'"
            >{{ itemDetail.biddings.length }}</em>）</el-button>
          </li>

        </ul>
      </div>

    </div>

    <div
      class="tab_content_w"
      :style="{
        'padding-top': isActiveTab ? navHeadHeight + 'px' : 0,
      }"
    >
      <div ref="firstTab" class="first_tab targets_w fz14 c_1A1A1A d_flex flex_direction_col">
        <!-- 项目信息 -->
        <table border="0" cellspacing="10">
          <tr>
            <!-- 注意该rowspan="" -->
            <td rowspan="11" class="table_title" style="width: 85px">项目信息</td>
            <td class="w_td font_w_bold">项目名称</td>
            <td class="td_val_2 text_left">
              {{ projectInfo.title }}
            </td>

            <td class=" font_w_bold">项目编号</td>
            <td class="td_val_2 text_left">{{ projectInfo.projectNo }}</td>
          </tr>

          <tr>
            <td class="font_w_bold">交易方式</td>
            <td class="max_w_107 text_left">
              {{ tradeModeKey[projectInfo.tradeMode] }}
            </td>
            <td class=" font_w_bold">招标类型</td>
            <td class="td_val_2 text_left">{{ biddingTypeKey[projectInfo.biddingType] }}</td>
          </tr>

          <tr>
            <td class="font_w_bold">项目周期</td>
            <td class="text_left">{{ projectInfo.deadline }}{{ deadlineUnitKey[projectInfo.deadlineUnit] }}</td>
            <td class="font_w_bold">挂牌价格</td>
            <td class="text_left">{{ projectInfo.price }}{{ projectInfo.priceUnitDesc }}<span
              v-if="projectInfo.priceUnit === 'zongjia'"
            >({{ priceUnitKey[projectInfo.priceUnit] }})</span></td>
          </tr>

          <tr v-if="isAuction">
            <td class="font_w_bold">挂牌期限</td>
            <td colspan="3" class="text_left">
              {{ projectInfo.listingStartAt
              }}<span style="margin: 0 15px">至</span>{{ projectInfo.listingEndAt }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">所在区域</td>
            <td class="text_left" colspan="3">
              {{ projectInfo.area }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">详细地址</td>
            <td class="text_left" colspan="3">
              {{ projectInfo.address }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">付款方式</td>
            <td class="text_left">
              {{ paymentModeKey[projectInfo.paymentMode] }}
            </td>
            <td class="font_w_bold">资金性质</td>
            <td class="text_left">
              {{ capitalPropertyKey[projectInfo.capitalProperty] }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">资金来源</td>
            <td class="text_left" colspan="3">
              {{ projectInfo.capitalSource }}
            </td>

          </tr>

          <tr>
            <td class="font_w_bold">其他说明</td>
            <td class="text_left" colspan="3">
              {{ projectInfo.remark }}
            </td>
          </tr>

        </table>

        <!-- 招标方信息 -->
        <table border="0" cellspacing="10">
          <tr>
            <!-- 注意该rowspan="" -->
            <td rowspan="11" class="table_title" style="width: 85px">招标方信息</td>

            <td class="w_td font_w_bold">招标方名称</td>
            <td class="td_val_2 text_left">{{ projectInfo.subject.name }}</td>
            <td class="font_w_bold">法定代表人</td>
            <td class="td_val_2 text_left">{{ projectInfo.subject.contact }}</td>
          </tr>

          <tr>
            <td class="font_w_bold">联系方式</td>
            <td class="text_left">{{ projectInfo.subject.contactWay }}</td>
            <td class="font_w_bold">联系地址</td>
            <td class="text_left">{{ projectInfo.subject.address }}</td>
          </tr>
        </table>

        <!-- 招标信息 -->
        <table border="0" cellspacing="10">

          <tr>
            <!-- 注意该rowspan="" -->
            <td rowspan="11" class="table_title" style="width: 85px">招标信息</td>
            <td class="w_td font_w_bold">投标人条件</td>
            <td class=" text_left" colspan="3">
              {{ projectInfo.term }}
            </td>

          </tr>

          <tr>
            <td class=" font_w_bold">项目描述</td>
            <td class=" text_left" colspan="3">{{ projectInfo.describe }}</td>
          </tr>

        </table>

        <!-- 竞价规则 -->
        <table border="0" cellspacing="10">
          <tr>
            <td rowspan="20" class="table_title" style="width: 85px">竞价规则</td>
            <td class="w_td font_w_bold">是否缴纳交易保证金</td>
            <td class="max_w_107 text_left">
              {{ whether[itemDetail.deposit] }}
            </td>
            <td class="w_td font_w_bold">交易保证金</td>
            <td class="max_w_107 text_left">{{ itemDetail.margin || 0 }}元</td>
          </tr>

          <tr>
            <td class="font_w_bold">竞价方式</td>
            <td class="max_w_107 text_left">
              {{ auctionModeKey[itemDetail.auctionMode] }}
            </td>
            <td class="font_w_bold">竞价幅度</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.auctionRange || 0 }}元
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">出价次数</td>
            <td class="max_w_107 text_left">
              {{ bidCountKey[itemDetail.bidCount] }}
            </td>
            <td class="font_w_bold">竞价方向</td>
            <td class="max_w_107 text_left">
              {{ directionKey[itemDetail.direction] }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">是否延时</td>
            <td class="max_w_107 text_left">
              {{ whether[itemDetail.delay] }}
            </td>
            <td class="font_w_bold">延时周期</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.delayedMinute }}分钟/次
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">报名延期</td>
            <td colspan="3" class="text_left">{{ delayKey[itemDetail.auctionDelay] }}</td>
          </tr>

          <tr>
            <td class="font_w_bold">报名开始时间</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.applyStartTime }}
            </td>
            <td class="font_w_bold">报名结束时间</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.applyEndTime }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">竞价开始时间</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.auctionStartTime }}
            </td>
            <td class="font_w_bold">竞价结束时间</td>
            <td class="max_w_107 text_left">
              {{ itemDetail.auctionEndTime }}
            </td>
          </tr>
        </table>

        <!-- 账户信息 -->
        <table v-if="itemDetail.bankCard" border="0" cellspacing="10">
          <tr>
            <td rowspan="5" class="table_title" style="width: 85px">账户信息</td>
            <td class="w_td font_w_bold">账户名称</td>
            <td class="text_left">
              {{ itemDetail.bankCard.accountName }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">开 户 行</td>
            <td class="text_left">
              {{ itemDetail.bankCard.openBank }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">银行账号</td>
            <td class="text_left">
              {{ itemDetail.bankCard.bankCard }}
            </td>
          </tr>

          <tr>
            <td class="font_w_bold">转账备注</td>
            <td class="text_left">交易保证金打款时务必注明项目名称</td>
          </tr>
        </table>

        <!-- 实景图 -->
        <div
          v-if="projectInfo.realisticImgs.length"
          id="_realisticImgs"
          class="realistic_picture_w d_flex flex_wrap text_center"
        >
          <el-image
            v-for="(item, index) in projectInfo.realisticImgs"
            :key="index"
            class="pic_i"
            :src="item + '!443'"
            alt=""
            :preview-src-list="projectInfo.realisticImgs"
          />

        </div>
      </div>

      <!-- 相关附件 -->
      <div
        v-if="hasOtherAttachs"
        ref="secondTab"
        class="second_tab tab_w text_center"
      >

        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>相关附件</span><span class="line" />
        </div>

        <div class=" fz14">
          <div v-for="(item, index) in otherAttachs" :key="index" class="attachs_item text_left">
            <span>附件{{ index + 1 }}：</span>
            <span
              class="cursor_pointer c_2CAEFF"
              @click="
                openPreviewFile({
                  file: {
                    url: item.url,
                    name: item.name,
                  },
                  bucket: Bucket_pub,
                  url: '/user/sts/public',
                })
              "
            >{{ item.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- 出价记录 -->
      <div
        id="_bid"
        ref="thirdTab"
        class="tab_w"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>出价记录</span><span class="line" />
        </div>

        <div class="tab_c_w">
          <div class=" letter_spacing_1" style="margin-top:20px">
            <div class=" bc_F2F2F2 c_808080 d_flex text_center fz16" style="padding:17px 0">
              <div style="width:200px">状态</div>
              <div style="width:300px">竞买方</div>
              <div style="width:315px">价格</div>
              <div style="width:362px">出价时间</div>
            </div>

            <div v-if="itemDetail">
              <div
                v-for="(item, index) in itemDetail.biddings"
                :key="item.id"
                class="biddings_w d_flex text_center fz14"
              >
                <div v-if="index === 0" class="cell_item " style="width:200px">
                  <span class="state_text">{{
                    itemDetail.state === 9 ? "成交" : "领先"
                  }}</span>
                </div>
                <div v-else class="cell_item " style="width:200px">
                  <span class="state_text">出局</span>
                </div>
                <div class="cell_item " style="width:300px">{{ item.phone }}</div>
                <div class="cell_item " style="width:315px">
                  {{ numTranFloat(item.bidPrice) }}
                </div>
                <div class="cell_item " style="width:362px">{{ item.createdAt }}</div>
              </div>
            </div>

            <div
              v-if="itemDetail.biddings && !itemDetail.biddings.length"
              class="x_y_center site_min_h"
            >
              <img src="@/assets/images/empty_icon.png" alt="">
              <span style="margin: 0 0 0 10px">暂无数据</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <ImportJs :src="`${static_resource}/js/oss.js`" script-key="oss" @loadComplete="ossCompleteFn" />

  </div>

</template>

<script>

import { mapGetters, mapMutations, mapActions } from 'vuex'

import {
  debounce,
  numTranFloat
} from '@/utils'
import ImportJs from '@/components/base/ImportJs.vue'

export default {
  components: {
    ImportJs
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      navHeadOffsetTop: 0, // 距离窗口顶部距离
      navHeadScrollTop: 0, // 滚动距离窗口顶部距离
      navHeadHeight: 0,

      firstTab: '',
      secondTab: '',
      thirdTab: '',

      firstActive: false,
      secondActive: false,
      thirdActive: false

    }
  },
  computed: {
    ...mapGetters([
      'siteInfo',
      'deadlineUnitKey', 'capitalPropertyKey', 'biddingTypeKey', 'paymentModeKey', 'tradeModeKey',
      'whether', 'auctionModeKey', 'bidCountKey', 'directionKey', 'delayKey',
      'Bucket_pub',
      'priceUnitKey',
      'static_resource'
    ]),

    // 格式化金额（小数点）
    formatMoney: function() {
      return function(num) {
        return Number(num).toLocaleString()
      }
    },

    isActiveTab() {
      return this.navHeadScrollTop < 0
    },
    // 项目信息
    projectInfo() {
      return this.itemDetail?.project || this.itemDetail
    },
    // 相关附件
    otherAttachs() {
      return this.itemDetail?.project?.otherAttachs || this.itemDetail.otherAttachs
    },
    // 是否包含相关附件
    hasOtherAttachs() {
      return this.otherAttachs?.length
    },
    // 是竞价项目
    isAuction() {
      return this.projectInfo.tradeMode === 1
    },
    numTranFloat: function() {
      return function(num) {
        return numTranFloat(num)
      }
    }
  },
  watch: {
    projectInfo: {
      handler(n) {
        if (Object.keys(n).length) {
          this.$nextTick(() => {
            const navHead = this.$refs?.navHead
            this.navHeadHeight = Number(navHead.clientHeight)
            this.navHeadOffsetTop = Number(navHead.offsetTop)
            setTimeout(() => {
              this.initTabTitleRef()
            }, 0)

            window.onscroll = debounce(() => {
              this.baseInfoTabActive()
              this.otherTabActive()
              this.recordTabActive()

              this.navHeadScrollTop =
              this.navHeadOffsetTop - document.documentElement.scrollTop
            }, 10)
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  destroyed() {
    window.onscroll = null
  },
  methods: {
    ...mapMutations({
      ossCompleteFn: 'app/ossCompleteFn'
    }),
    ...mapActions({
      openPreviewFile: 'upload/openPreviewFile',
      initBidding: 'cache/initBidding'
    }),

    // 预览文件 click
    onFileClick(file) {
      window.open(file.url, '_blank')
    },

    // tab项目信息激活
    baseInfoTabActive() {
      if (!this.firstTab) return
      const top =
      this.firstTab.offsetTop -
      this.navHeadHeight -
      document.documentElement.scrollTop
      const bottom = top + this.firstTab.offsetHeight
      this.firstActive = top <= 0 && bottom >= 0
    },

    // tab相关附件激活
    otherTabActive() {
      if (!this.secondTab) return
      const top =
        this.secondTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.secondTab.offsetHeight
      this.secondActive = top <= 0 && bottom >= 0
    },
    // tab出价记录激活
    recordTabActive() {
      if (!this.thirdTab) return
      const top =
        this.thirdTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.thirdTab.offsetHeight
      this.thirdActive = top <= 0 && bottom >= 0
    },

    // 点击tab项 click
    onTabAnchor(id) {
      const el = this.$refs[id] || this.$refs[id]
      window.scrollTo(0, el.offsetTop - 44)
    },
    // 获取tab标题dom
    initTabTitleRef() {
      this.firstTab = this.$refs.firstTab
      this.secondTab = this.$refs.secondTab
      this.thirdTab = this.$refs.thirdTab
    }

  }
}
</script>

<style lang='scss' scoped>

::v-deep .leaflet-popup-content-wrapper {
  border-radius: 4px;
  .leaflet-popup-content {
    margin: 10px;
  }
}
::v-deep .leaflet-popup-tip {
  width: 12px;
  height: 12px;
}

.tab_nav_w {
  margin: 0 0 50px 0;
  padding-bottom: 50px;

}

::v-deep  .tab_w:nth-child(3){
  border-bottom: 1px solid #e6e6e6;
}
::v-deep .tab_w {
    // width: 876px;
    // padding: 0 20px;

    .title_w {
      padding: 30px 0;
      font-size: 24px;
      & span {
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
      .line {
        display: inline-block;
        width: 42px;
        height: 2px;
        background: #0983cc;
      }
    }

  }

::v-deep .targets_w {
  & > table {
    width: 100%;
    // border-color: #e6e6e6;

    //标准单元格宽度
    .w_td {
      width: 147px;
      white-space: nowrap;
    }
    //最大单元格宽度164
    .max_w_164 {
      max-width: 164px;
    }
    //最大单元格宽度210
    .max_w_210 {
      max-width: 210px;
    }
    .td_val_2 {
      width: 250px;
    }
    //最大单元格宽度696
    .max_w_696 {
      max-width: 696px;
    }

    &:last-of-type{
      border-bottom: 1px solid #e6e6e6;
    }
    tr {
      &:first-child {
        td {
          &:first-child {
            border-left: 1px solid #e6e6e6;
          }
        }
      }
      td {
        word-break: break-word;
        box-sizing: border-box;
        padding: 20px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
      }
    }
    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }
  }
}
.location_w {
  margin: 50px 0 20px 0;
}
.nav_w {
  .nav_head {
    position: relative;
    background: #f2f2f2;
    z-index: 403;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;

    & li {
      width: 140px;
      text-align: center;
      cursor: pointer;
      border-right: 1px solid #e6e6e6;

      & .el-button {
        width: 140px;
        height: 46px;
        background-color: #f2f2f2;
        border: 0;
        &:active,
        &:focus {
          color: inherit;
          background-color: inherit;
        }
        &:hover{
          color: inherit;
        }
        &.is_active {
          background-color: #0983cc;
          color: #fff;
          border-color: #0983cc;
        }
      }
      &:last-child {
        border: 0;
      }
    }
  }
  .is_fixed {
    position: fixed;
    top: 0;
  }
}
.tab_content_w{
  padding: 20px;
  .first_tab{
    padding-top: 20px;
  }
  .second_tab{
    .attachs_item{
      margin-bottom: 5px;
    }
  }
}

.realistic_picture_w{
  margin: 20px 0 0 0;
  .pic_i{
    width: 100%;
    margin: 0 0 30px 0;
    &:last-child{
      margin: 0;
    }
  }
}

.tab_w {

  .cell_item {
    padding: 14px 0;
    border-bottom: 1px solid #e6e6e6;
  }

}
</style>
